import React from 'react'
import HubspotForm from 'react-hubspot-form';

const RequestCatalog = ({ containerObject, templateName, contentId, dataZone }) => {
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >

            <div id="content" class="one-column full">
                <h2>Catalog Request Form</h2>

                <p>Please complete the form below to have a printed copy of our catalog mailed to you.</p>

                <p>&nbsp;</p>

                <p><br />
                    <HubspotForm
                        portalId='44059706'
                        formId="71c2886b-89b4-423a-9ea0-f022d75cf974"
                        region="na1"
                        onSubmit={() => console.log('Submit!')}
                    />
                </p>

                <p>&nbsp;</p>

            </div>
        </div>

    )
}

export default RequestCatalog